import {CSSProperties, FC, ReactNode} from 'react'
import styles from './styles.module.scss'

type HorizontalDividerProps = {
  children?: ReactNode
  className?: string
  style?: CSSProperties
}


export const HorizontalDivider: FC<HorizontalDividerProps> = ({children, className, style}) => {

  return (
    <div style={style} className={`${styles.container} ${className || ''}`}>
      <div className={styles.border} />
      {children ? <span className={styles.content}>
        {children}
      </span> : null}
      <div className={styles.border} />
    </div>
  )
}